import { IAPIRoutes } from "../../../../config";

export type IClinicRepository = ReturnType<typeof ClinicRepositoryFactory>;

export const ClinicRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST, PATCH } = APIProvider;

  const getPsnSettings: IGetPsnSettingsAPI = async ({ clinic_id }) =>
    GET(APIRoutes.apiPsnSettings.replace("{clinic_id}", String(clinic_id)), {});

  const patchPsnSettings: IPatchPsnSettingsAPI = async ({
    clinic_id,
    ...body
  }) =>
    PATCH(
      APIRoutes.apiPsnSettings.replace("{clinic_id}", String(clinic_id)),
      body
    );
  const { getAuthenticationToken } = AuthService;

  const getClinicID: IGetMyClinicAPI = async () =>
    GET(
      APIRoutes.apiMyClinic,
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getClinicFloor: IGetClinicFloorAPI = async (obj) =>
    GET(
      APIRoutes.apiGetClinicFloor.replace("{clinic_id}", String(obj.clinic_id)),
      obj,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const setClinicFloor: ISetClinicFloorAPI = async ({ clinic_id, ...obj }) =>
    POST(
      APIRoutes.apiSetClinicFloor.replace("{clinic_id}", clinic_id?.toString()),
      obj,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const logError: ILogErrorAPI = async (obj) =>
    POST(APIRoutes.apiMixPanelErrorStore, obj, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });

  const updateFacilityInformation: IUpdateFacilityInformationAPI = async (
    obj
  ) =>
    PATCH(
      APIRoutes.apiUpdateFacilityInformation.replace(
        "{clinic_id}",
        obj.clinic_id.toString()
      ),
      obj,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getClinicConfig: IGetClinicConfigAPI = async ({ clinic_id }) =>
    GET(
      APIRoutes.apiClinicConfig.replace("{clinic_id}", clinic_id.toString()),
      {}
    );

  const patchClinicConfig: IPatchClinicConfigAPI = async ({
    clinic_id,
    ...obj
  }) =>
    PATCH(
      APIRoutes.apiClinicConfig.replace("{clinic_id}", clinic_id.toString()),
      obj
    );

  const getClinicShiftReportConfig: IGetClinicShiftReportConfigAPI = async ({
    clinic_id,
  }) =>
    GET(
      APIRoutes.apiClinicShiftReportConfig.replace(
        "{clinic_id}",
        clinic_id.toString()
      ),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getClinicFloor,
    getClinicID,
    setClinicFloor,
    logError,
    updateFacilityInformation,
    getPsnSettings,
    patchPsnSettings,
    getClinicConfig,
    patchClinicConfig,
    getClinicShiftReportConfig,
  };
};
